module.exports = __webpack_public_path__ + "media/images/product_picture-5aac1922d133242e6ab608ea894b2cd1.svg";